import { FieldType } from '@framework/core/Enums';
import { IEntityModelField, IEntityModel } from '@framework/interfaces/IEntityModel';
export interface IRoleProjectJobNumberFields {
		id?: any;
		status?: any;
		datestamp?: any;
		changedById?: any;
		roleId?: any;
		projectNumberId?: any;
		exclude?: any;
}

export class RoleProjectJobNumberFields extends Array<IEntityModelField> {
	public id: IEntityModelField = { name: "id", displayName: "Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true, keyField: true };
	public status: IEntityModelField = { name: "status", displayName: "Status", fieldType: FieldType.Int, pattern: "NameGeneric", required: true };
	public datestamp: IEntityModelField = { name: "datestamp", displayName: "Datestamp", fieldType: FieldType.DateTime, pattern: "NameGeneric", required: true };
	public changedById: IEntityModelField = { name: "changedById", displayName: "Changed By Id", fieldType: FieldType.String, pattern: "NameGeneric", required: true };
	public roleId: IEntityModelField = { name: "roleId", displayName: "Role Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public projectNumberId: IEntityModelField = { name: "projectNumberId", displayName: "Project Number Id", fieldType: FieldType.String, pattern: "NameGeneric" };
	public exclude: IEntityModelField = { name: "exclude", displayName: "Exclude", fieldType: FieldType.Byte, pattern: "NameGeneric" };

	constructor() {
		super();
		this.push(this.id);
		this.push(this.status);
		this.push(this.datestamp);
		this.push(this.changedById);
		this.push(this.roleId);
		this.push(this.projectNumberId);
		this.push(this.exclude);
	}
}

export class RoleProjectJobNumberDTO implements IEntityModel {
	protected roleProjectJobNumberName: string = "RoleProjectJobNumberModel";
	protected roleProjectJobNumberKeyField: string = "id";
	protected roleProjectJobNumberDisplayName: string = "Role Project Job Number|Role Project Job Numbers";
	protected roleProjectJobNumberFields = new RoleProjectJobNumberFields();
	public get name(): string { return this.roleProjectJobNumberName };
	public get keyField(): string { return this.roleProjectJobNumberKeyField };
	public get displayName(): string { return this.roleProjectJobNumberDisplayName };
	public get fields(): RoleProjectJobNumberFields { return this.roleProjectJobNumberFields };

	constructor() {};
}
